import { GuideStatuses } from 'constants/guide';

export const isGuideStatusComplete = (status) => status && status === GuideStatuses.COMPLETE;
export const isGuideStatusFailed = (status) => status && status === GuideStatuses.FAILED;
export const isGuideStatusIncomplete = (status) => status && status === GuideStatuses.INCOMPLETE;
export const isGuideStatusPending = (status) => status && status === GuideStatuses.PENDING;
